import { handleActions } from "redux-actions";
import {
  SET_APP_VERSION,
  SET_FLOOR,
  SET_LOCALE,
  SET_COUNTRY,
  SET_PLATFORM,
  SET_CURRENCY,
  SET_STORE_URL,
  SET_SIZE_SCHEMA,
  SET_GEOLOCATION,
  SET_LOYALTY_IS_ENABLED,
  SET_LOYALTY_TIER,
  SET_LOYALTY_IS_OPTED_IN,
  SET_MEMBERS_DAY_SALE_EVENT,
  SET_LOYALTY_IS_BENEFIT_AVAILABLE,
  SET_LOYALTY_IS_BENEFIT_EVENT_ACTIVE,
  SET_LOYALTY_ENABLE_COMPLIANCE_VARIANT
} from "./constants";

// TODO: grab this from config.countries
export const initialState = {
  locale: "en-GB",
  country: {
    siteId: 1,
    storeCode: "COM",
    defaultLanguage: "en-GB",
    defaultSizeSchema: "UK",
    defaultCurrency: "GBP",
    url: "http://www.asos.com/",
    countryCode: "GB",
    imageUrl: "/assets/storesa/images/flags/gb.png",
    name: "United Kingdom",
    majorCountry: null,
    isDefaultCountry: true,
    keyStoreDataVersion: 1,
    geolocation: {},
    loyalty: {
      isEnabled: false,
      isOptedIn: false,
      tier: null,
      isBenefitAvailable: {},
      isBenefitEventActive: {},
      enableComplianceVariant: false
    }
  },
  platform: "mobile"
};

export default handleActions(
  {
    [SET_FLOOR]: (state, action) => ({
      ...state,
      floor: action.payload
    }),
    [SET_LOCALE]: (state, action) => ({
      ...state,
      locale: action.payload
    }),
    [SET_PLATFORM]: (state, action) => ({
      ...state,
      platform: action.payload
    }),
    [SET_SIZE_SCHEMA]: (state, action) => ({
      ...state,
      sizeSchema: action.payload
    }),
    [SET_COUNTRY]: (state, action) => ({
      ...state,
      country: action.payload
    }),
    [SET_CURRENCY]: (state, action) => ({
      ...state,
      currency: action.payload
    }),
    [SET_STORE_URL]: (state, action) => ({
      ...state,
      storeUrl: action.payload
    }),
    [SET_GEOLOCATION]: (state, action) => ({
      ...state,
      geolocation: action.payload
    }),
    [SET_LOYALTY_IS_ENABLED]: (state, { payload }) => ({
      ...state,
      loyalty: {
        ...state.loyalty,
        isEnabled: payload
      }
    }),
    [SET_MEMBERS_DAY_SALE_EVENT]: (state, { payload }) => ({
      ...state,
      loyalty: {
        ...state.loyalty,
        membersDaySaleEvent: payload
      }
    }),
    [SET_LOYALTY_TIER]: (state, { payload }) => ({
      ...state,
      loyalty: {
        ...state.loyalty,
        tier: payload
      }
    }),
    [SET_LOYALTY_IS_OPTED_IN]: (state, { payload }) => ({
      ...state,
      loyalty: {
        ...state.loyalty,
        isOptedIn: payload
      }
    }),
    [SET_LOYALTY_IS_BENEFIT_AVAILABLE]: (state, { payload }) => ({
      ...state,
      loyalty: {
        ...state.loyalty,
        isBenefitAvailable: {
          ...state.loyalty.isBenefitAvailable,
          ...payload
        }
      }
    }),
    [SET_LOYALTY_IS_BENEFIT_EVENT_ACTIVE]: (state, { payload }) => ({
      ...state,
      loyalty: {
        ...state.loyalty,
        isBenefitActive: {
          ...state.loyalty.isBenefitActive,
          ...payload
        }
      }
    }),
    [SET_LOYALTY_ENABLE_COMPLIANCE_VARIANT]: (state, { payload }) => ({
      ...state,
      loyalty: {
        ...state.loyalty,
        enableComplianceVariant: payload
      }
    }),
    [SET_APP_VERSION]: (state, { payload }) => ({
      ...state,
      appVersion: payload
    })
  },
  initialState
);
